import { Link } from "@mui/material";

import type { UUID } from "../../../utils/uuid";
import type { MomentStatus } from "../../moment-card/types";

interface ProgramTab {
  value: string;
  label: string;
  showCreate: boolean;
  emptyStateMessage?: string | React.JSX.Element;
  status?: MomentStatus[];
}

export const useProgramTabs = (programId?: UUID): ProgramTab[] => [
  {
    value: "active",
    label: "Published and Drafts",
    showCreate: true,
    emptyStateMessage: (
      <>
        {"There are no Published or Draft Communications. "}
        {programId !== undefined && (
          <>
            <Link href={`/moments?programId=${programId}`}>Create a new Communication</Link> or{" "}
            <Link href="/discover">Discover one from our Library</Link>
          </>
        )}
      </>
    ),
    status: ["active", "draft"],
  },
  {
    value: "finished",
    label: "Finished",
    showCreate: false,
    emptyStateMessage:
      "There are no finished Communications. A Communication is finished when it has completed all its sends.",
    status: ["finished"],
  },
  {
    value: "archived",
    label: "Archived",
    showCreate: false,
    emptyStateMessage: "There are no archived Communication.",
    status: ["archived"],
  },
];
